import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
import PerDatePicker, { DatePickerProps } from '../custom_components/DatePicker'

export type FormikDatePickerProps = FormikFieldProps & Partial<DatePickerProps>

export const FormikDatePicker = ({
  inputDate,
  name,
  validate,
  timeZoneAndLocale,
  disabled,
  dateFormat,
  size,
  ...restProps
}: FormikDatePickerProps): JSX.Element => (
  <Field name={name} validate={validate}>
    {({ field: { value }, form: { setFieldValue, setFieldTouched } }: FieldProps) => {
      return (
        <PerDatePicker
          inputDate={inputDate ? inputDate : value}
          onDateChanged={(utcDateChanged) => {
            setFieldValue(name, utcDateChanged ? utcDateChanged : '')
            setFieldTouched(name, true)
          }}
          timeZoneAndLocale={timeZoneAndLocale ? timeZoneAndLocale : { locale: 'de_DE', timezone: 'Europe/Berlin' }}
          dateFormat={dateFormat ? dateFormat : 'DMY'}
          disabled={disabled}
          size={size}
          {...restProps}
        />
      )
    }}
  </Field>
)
